import { ErrorMessage, Field, Formik, Form } from 'formik';
import React, { useEffect, useState } from 'react';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { createActionSettingsSchema, getFieldInfoByName } from './Util';
import CustomLoader from '../../../common/CustomLoader';
import { filterFieldsOfCollection } from '../../../common/FieldTypes';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { iconForField } from '../../../../common/custom/icon-library';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import BrowserStorageOptions from '../BrowserStorageOptions';
import ConsoleLogOptions from '../../ConsoleLogOptions';

export const CollectionitemWithUserForm = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  events,
  actions,
  hideModal,
  showLoaderForAction,
  version,
}) => {
  const [userRoles, setUserRoles] = useState([]);
  const [showBSLOption, setShowBSLOption] = useState(false);
  const [showCLOption, setShowCLOption] = useState(false);

  useEffect(() => {
    getCollectionItem('role').then((res) => {
      setUserRoles(res.data);
    });
  }, []);

  const getCollectionItem = async (collectionName) => {
    const header = builderSurfaceJsonContentHeader(projectId);
    return await axios.get(
      `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/`,
      header,
    );
  };

  const collectionOptions = () => {
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  const userFieldsOptions = () => {
    let options = [{ value: '', label: 'Choose Field' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      const userCollection = collections.find((coll) => coll.collectionName === 'user');
      if (userCollection && userCollection.fields) {
        const userFields = filterFieldsOfCollection(userCollection);
        options = options.concat(
          userFields.map((field) => {
            return { value: field.fieldName, label: field.fieldTitle.en };
          }),
        );
      }
    }
    return options;
  };

  const userRolesOptions = () => {
    let options = [{ value: '', label: 'Choose User Role' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        userRoles.map((item) => {
          return { value: item.name, label: item.name };
        }),
      );
    }
    return options;
  };

  const getPageOption = () => {
    let options = [];
    const { pages } = events || '';
    const pageOptions =
      pages && pages.length > 0
        ? pages.map((item, key) => {
            return { value: '/' + item.slug, label: item.name };
          })
        : [];
    return [...options, ...pageOptions];
  };

  const handleSubmit = (values) => {
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });

    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  const bslOptionHandler = () => {
    setShowBSLOption(!showBSLOption);
  };

  const clogOptionHandler = () => {
    setShowCLOption(!showCLOption);
  };

  const browserStorageLocationOptions = () => {
    let options = [
      { value: 'SESSION_STORAGE', label: 'Session Storage (Default)' },
      { value: 'LOCAL_STORAGE', label: 'Local Storage' },
      { value: 'COOKIES', label: 'Cookies' },
      { value: 'INDEXED_DB', label: 'IndexedDB' },
    ];
    return options;
  };

  const validateFormDataSessionKey = (value) => {
    let error;
    if (!value) {
      error = "Form Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Form Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Form Data Session Key can not be more than 50 characters';
    }
    return error;
  };
  const validateResponseDataSessionKey = (value) => {
    let error;
    if (!value) {
      error = "Response Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Response Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Response Data Session Key can not be more than 50 characters';
    }
    return error;
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema(actionData, eventAction)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
      }}
    >
      {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
        <Form>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Parent Collection"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Select Parent Collection which you want to Create Item For.'}
                >
                  <CustomSelect
                    name={'collection'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={collectionOptions()}
                    value={values['collection']}
                  />
                  <ErrorMessage name={'collection'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="User Reference Field"
                  icon="select"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('userRefField')}
                >
                  <CustomSelect
                    name={'userRefField'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={userFieldsOptions()}
                    value={values['userRefField']}
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="User Role"
                  icon="select"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('userRole')}
                >
                  <CustomSelect
                    name={'userRole'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={userRolesOptions()}
                    value={values['userRole']}
                    formValues={values}
                    setFieldValue={setFieldValue}
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Success Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('successMessage')}
                >
                  <Field
                    name="successMessage"
                    type="text"
                    placeholder="(Optional) Enter custom success message."
                    className="form-control form-control-sm"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Error Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('errorMessage')}
                >
                  <Field
                    name="errorMessage"
                    type="text"
                    placeholder="(Optional) Enter custom error message."
                    className="form-control form-control-sm"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="form-group">
              <div className="col-12">
                <FormFieldWithLabel
                  cta={false}
                  label=""
                  icon="boolean-toggle"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('enableLoginUser')}
                >
                  <div className="form-check">
                    <label className="form-check-label">
                      <Field
                        type="checkbox"
                        name="enableLoginUser"
                        className="form-check-input"
                        title="enableLoginUser"
                      />
                      Login with recently created user
                      <span className="form-check-sign">
                        <span className="check"></span>
                      </span>
                    </label>
                    <ErrorMessage name="enableLoginUser">
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </div>
                </FormFieldWithLabel>
              </div>
            </div>
            {values.enableLoginUser && (
              <div className="col-12">
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Page"
                    icon="select"
                    infoIcon={true}
                    infoDescription={getFieldInfoByName('redirectUrl')}
                  >
                    <CustomSelect
                      name={'redirectUrl'}
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={getPageOption()}
                      value={values['redirectUrl']}
                      formValues={values}
                      setFieldValue={setFieldValue}
                      placeholder={'Select Page'}
                    />
                  </FormFieldWithLabel>
                </div>
              </div>
            )}
            <div className="col-12">
              <div className="form-group">
                <button
                  onClick={(e) => bslOptionHandler(e)}
                  className="btn btn-icon-only btn-outline-info ml-5 p-1"
                  title="Show Browser Storage Options"
                  type="button"
                >
                  <i className="wb webconnect-cog"></i>&nbsp;Browser Storage Options
                </button>
                <button
                  onClick={(e) => clogOptionHandler(e)}
                  className="btn btn-icon-only btn-outline-info ml-2 p-1"
                  title="Show Console Log Options"
                  type="button"
                >
                  <i className="wb webconnect-cog"></i>&nbsp;Console Log Options
                </button>
              </div>
              {/* {showBSLOption && (
                <div style={{ marginLeft: '30px' }}>
                  <div className="form-group">
                    <div className="input-group">
                      <div
                        className="input-group-prepend"
                        title="Save Form Submission Data In Browser Session Storage"
                      >
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                        </span>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <Field
                            type="checkbox"
                            name="passPreviousActionFormData"
                            className="form-check-input"
                            title="passPreviousActionFormData"
                          />
                          Save Form Submission Data In Browser Storage
                          <span className="form-check-sign">
                            <span className="check"></span>
                          </span>
                        </label>
                      </div>
                      <TooltipInfo
                        title={`Enable it to save form submission data in your web browser storage.`}
                        headerText={`What's this ?`}
                        showHeader={true}
                        showArrow={true}
                        append={true}
                      />
                    </div>
                    <ErrorMessage
                      name="passPreviousActionFormData"
                      component="p"
                      className="text-error ml-5"
                    />
                  </div>
                  {values['passPreviousActionFormData'] && (
                    <>
                      <div className="form-group">
                        <div className="input-group">
                          <div className="input-group-prepend" title="Form Data Session Key">
                            <span className="input-group-text">
                              <i className={`wb ${iconForField('text')}`}></i>
                              <span className="required"> *</span>
                            </span>
                          </div>
                          <Field
                            type="text"
                            name="formDataSessionKey"
                            className="form-control form-control-sm"
                            autoComplete="off"
                            placeholder="Form Data Session Key"
                            validate={validateFormDataSessionKey}
                          />
                          <TooltipInfo
                            title={`Enter the key in which you want to save form submission data in your web browser storage.`}
                            headerText={`What's this ?`}
                            showHeader={true}
                            showArrow={true}
                            append={true}
                          />
                        </div>
                        <ErrorMessage
                          name="formDataSessionKey"
                          component="p"
                          className="text-error ml-5"
                        />
                      </div>
                      <div className="form-group">
                        <div className="input-group">
                          <div
                            className="input-group-prepend"
                            title="Session Storage Location (Optional)"
                          >
                            <span className="input-group-text">
                              <i className={`wb ${iconForField('select')}`}></i>
                              <span className="required"> *</span>
                            </span>
                          </div>
                          <CustomSelect
                            name={'formDataBrowserStorageLocation'}
                            isMulti={false}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            options={browserStorageLocationOptions()}
                            value={values['formDataBrowserStorageLocation']}
                            placeholder={'Session Storage Location (Optional)'}
                          />
                          <TooltipInfo
                            title={`Select the browser storage location where you want to set the key:value data in your web browser storage.`}
                            headerText={`What's this ?`}
                            showHeader={true}
                            showArrow={true}
                            append={true}
                          />
                        </div>
                        <small style={{ paddingLeft: '12%' }}>
                          Select a browser storage location to set a value (Default: Session
                          Storage).
                        </small>
                        <ErrorMessage
                          name="formDataBrowserStorageLocation"
                          component="p"
                          className="text-error ml-5"
                        />
                      </div>
                    </>
                  )}
                  <div className="form-group">
                    <div className="input-group">
                      <div
                        className="input-group-prepend"
                        title="Save Response Data In Browser Session Storage"
                      >
                        <span className="input-group-text">
                          <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                        </span>
                      </div>
                      <div className="form-check">
                        <label className="form-check-label">
                          <Field
                            type="checkbox"
                            name="passPreviousActionResponse"
                            className="form-check-input"
                            title="passPreviousActionResponse"
                          />
                          Save Response Data In Browser Storage
                          <span className="form-check-sign">
                            <span className="check"></span>
                          </span>
                        </label>
                      </div>
                      <TooltipInfo
                        title={`Enable it to save action response data in your web browser storage.`}
                        headerText={`What's this ?`}
                        showHeader={true}
                        showArrow={true}
                        append={true}
                      />
                    </div>
                    <ErrorMessage
                      name="passPreviousActionResponse"
                      component="p"
                      className="text-error ml-5"
                    />
                  </div>
                  {values['passPreviousActionResponse'] && (
                    <>
                      <div className="form-group">
                        <div className="input-group">
                          <div className="input-group-prepend" title="Response Data Session Key">
                            <span className="input-group-text">
                              <i className={`wb ${iconForField('text')}`}></i>
                              <span className="required"> *</span>
                            </span>
                          </div>
                          <Field
                            type="text"
                            name="responseDataSessionKey"
                            className="form-control form-control-sm"
                            autoComplete="off"
                            placeholder="Response Data Session Key"
                            validate={validateResponseDataSessionKey}
                          />
                          <TooltipInfo
                            title={`Enter the key in which you want to save response data in your web browser storage.`}
                            headerText={`What's this ?`}
                            showHeader={true}
                            showArrow={true}
                            append={true}
                          />
                        </div>
                        <ErrorMessage
                          name="responseDataSessionKey"
                          component="p"
                          className="text-error ml-5"
                        />
                      </div>
                      <div className="form-group">
                        <div className="input-group">
                          <div
                            className="input-group-prepend"
                            title="Session Storage Location (Optional)"
                          >
                            <span className="input-group-text">
                              <i className={`wb ${iconForField('select')}`}></i>
                              <span className="required"> *</span>
                            </span>
                          </div>
                          <CustomSelect
                            name={'responseDataSessionStorageLocation'}
                            isMulti={false}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            options={browserStorageLocationOptions()}
                            value={values['responseDataSessionStorageLocation']}
                            placeholder={'Session Storage Location (Optional)'}
                          />
                          <TooltipInfo
                            title={`Select the browser storage location where you want to set the key:value data in your web browser storage.`}
                            headerText={`What's this ?`}
                            showHeader={true}
                            showArrow={true}
                            append={true}
                          />
                        </div>
                        <small style={{ paddingLeft: '12%' }}>
                          Select a browser storage location to set a value (Default: Session
                          Storage).
                        </small>
                        <ErrorMessage
                          name="responseDataSessionStorageLocation"
                          component="p"
                          className="text-error ml-5"
                        />
                      </div>
                    </>
                  )}
                </div>
              )} */}
              {showBSLOption && (
                <BrowserStorageOptions
                  values={values}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  validateFormDataSessionKey={validateFormDataSessionKey}
                  validateResponseDataSessionKey={validateResponseDataSessionKey}
                />
              )}
              {showCLOption && <ConsoleLogOptions values={values} />}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-left">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={hideModal}
              >
                <span>
                  <i className="wb webconnect-times"></i>&nbsp;Cancel
                </span>
              </button>
            </div>
            <div className="col-md-6 text-right">
              <button type="submit" className="btn btn-theme-submit btn-sm">
                <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                <CustomLoader loading={showLoaderForAction} />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
